// import { useState } from "react";
// import { Link } from "react-router-dom";
// import { FiBell } from "react-icons/fi";

// const notifications = [
//   { id: 1, message: "New message from John", time: "2m ago" },
//   { id: 2, message: "Your order has been shipped", time: "1h ago" },
//   { id: 3, message: "System update scheduled at 2 AM", time: "5h ago" },
// ];

// const NotificationPopup = () => {
//   const [isOpen, setIsOpen] = useState(false);

//   return (
//     <div className="relative z-20">
//       {/* Notification Icon */}
//       <button
//         onClick={() => setIsOpen(!isOpen)}
//         className="relative focus:outline-none"
//       >
//         <FiBell className="text-white w-6 h-6 hover:text-blue-500" />
//         {/* Notification Count Badge */}
//         {notifications.length > 0 && (
//           <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
//             {notifications.length}
//           </span>
//         )}
//       </button>

//       {/* Notification Dropdown */}
//       {isOpen && (
//         <div className="absolute right-0 mt-2 w-64 bg-white shadow-lg rounded-lg overflow-hidden border border-gray-200">
//           <div className="max-h-60 overflow-y-auto">
//             {notifications.length > 0 ? (
//               notifications.map((notification) => (
//                 <div key={notification.id} className="px-4 py-3 border-b hover:bg-gray-100">
//                   <p className="text-sm text-gray-700">{notification.message}</p>
//                   <span className="text-xs text-gray-400">{notification.time}</span>
//                 </div>
//               ))
//             ) : (
//               <div className="p-4 text-sm text-gray-500 text-center">No new notifications</div>
//             )}
//           </div>
//           {/* Show All Button */}
//           <Link
//             to="/notifications123"
//             className="block w-full text-center bg-blue-500 text-white py-2 text-sm font-medium hover:bg-blue-600"
//           >
//             Show All
//           </Link>
//         </div>
//       )}
//     </div>
//   );
// };

// export default NotificationPopup;


import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { FiBell } from "react-icons/fi";

const notifications = [
  { id: 1, message: "New message from John", time: "2m ago" },
  { id: 2, message: "Your order has been shipped", time: "1h ago" },
  { id: 3, message: "System update scheduled at 2 AM", time: "5h ago" },
];

const NotificationPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef(null);

  // Close the popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
    {/* <div className="relative z-20" ref={popupRef}>
    
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="relative focus:outline-none"
      >
        <FiBell className="text-white w-6 h-6 hover:text-blue-500" />
 
        {notifications.length > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
            {notifications.length}
          </span>
        )}
      </button>


      {isOpen && (
        <div className="absolute right-0 mt-2 w-64 bg-white shadow-lg rounded-lg overflow-hidden border border-gray-200">
          <div className="max-h-60 overflow-y-auto">
            {notifications.length > 0 ? (
              notifications.map((notification) => (
                <div key={notification.id} className="px-4 py-3 border-b hover:bg-gray-100 cursor-pointer">
                  <p className="text-sm text-gray-700">{notification.message}</p>
                  <span className="text-xs text-gray-400">{notification.time}</span>
                </div>
              ))
            ) : (
              <div className="p-4 text-sm text-gray-500 text-center">No new notifications</div>
            )}
          </div>
       
          <Link
            to="/notifications"
            className="block w-full text-center bg-blue-500 text-white py-2 text-sm font-medium hover:bg-blue-600"
          >
            Show All
          </Link>
        </div>
      )}
    </div> */}
    </>
  );
};

export default NotificationPopup;
